import { Skeleton } from "./Skeleton";

/**
 * Skeleton loader matching PlSummaryCard layout.
 * Used across client dashboard when P&L summary is loading.
 */
export function PlSummaryCardSkeleton() {
  return (
    <div className="flex min-h-0 min-w-0 grow shrink-0 basis-0 flex-col items-start gap-6 rounded-2xl bg-white px-6 py-7 shadow-lg self-stretch sm:min-h-[22rem]">
      <div className="flex items-center gap-2">
        <Skeleton className="h-5 w-32" />
        <Skeleton className="h-5 w-5 rounded-full" />
      </div>
      <div className="flex flex-col items-start gap-2">
        <div className="flex gap-4 items-baseline">
          <Skeleton className="h-10 w-36" />
          <Skeleton className="h-6 w-14 rounded-full" />
        </div>
        <Skeleton className="h-4 w-44" />
      </div>
      <div className="mt-1 flex w-full flex-1 flex-col items-start justify-end gap-4 pt-5">
        <div className="flex w-full items-end gap-3">
          <div className="flex flex-col items-start gap-1.5 flex-1">
            <div className="relative flex w-full justify-center min-h-[128px]">
              <Skeleton className="absolute bottom-0 w-0.5 flex-none h-[72px]" />
              <Skeleton className="absolute bottom-[76px] h-7 w-[72px] rounded-full" />
            </div>
            <Skeleton className="h-2 w-full rounded-full" />
            <Skeleton className="h-4 w-16" />
          </div>
          <div className="flex flex-col items-start gap-1.5 flex-1">
            <div className="relative flex w-full justify-center min-h-[128px]">
              <Skeleton className="absolute bottom-0 w-0.5 flex-none h-12" />
              <Skeleton className="absolute bottom-14 h-7 w-[72px] rounded-full" />
            </div>
            <Skeleton className="h-2 w-full rounded-full" />
            <Skeleton className="h-4 w-16" />
          </div>
          <div className="flex flex-col items-start gap-1.5 flex-1">
            <div className="relative flex w-full justify-center min-h-[128px]">
              <Skeleton className="absolute bottom-0 w-0.5 flex-none h-8" />
              <Skeleton className="absolute bottom-10 h-7 w-[72px] rounded-full" />
            </div>
            <Skeleton className="h-2 w-full rounded-full" />
            <Skeleton className="h-4 w-16" />
          </div>
        </div>
      </div>
    </div>
  );
}
